import { onMounted, onBeforeUnmount } from 'vue';

// Adds a <script type="application/ld+json"> to <head> while the component is mounted.
export function useJsonLd(id, data) {
  let el;

  onMounted(() => {
    if (!data) return;
    const stale = document.getElementById(id);
    if (stale) stale.remove();
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    el.textContent = JSON.stringify(data);
    document.head.appendChild(el);
  });

  onBeforeUnmount(() => {
    // Remove only our own node, in case the next page already added one with this id.
    if (el && el.parentNode) el.parentNode.removeChild(el);
  });
}
